import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackEvent } from '../../../client/analytics';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

const EVENT_IDS = {
  SET_SCREENING_PREFERENCES_BUTTON: '4302',
  SET_TOUR_AVAILABILITY_IMPRESSION: '4308',
  SET_TOUR_AVAILABILITY_BUTTON: '6636',
} as const;

// https://dataportal.zillowgroup.net/event-registry/4302
const PostListingDashboardModalSetScreeningPreferencesButton = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.SET_SCREENING_PREFERENCES_BUTTON,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'listing_congrats_modal',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'set_preferences_button',
    },
    semantic: {
      semantic_event_nm: 'post_listing_workflow',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/4308
const PostListingDashboardModalSetTourAvailabilityImpression = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.SET_TOUR_AVAILABILITY_IMPRESSION,
      event_type_version_id: '3',
    },
    clickstream_trigger: {
      trigger_location_nm: 'listing_congrats_modal',
      trigger_type_nm: 'impression',
      trigger_object_nm: 'touring_modal',
      trigger_source_nm: 'no_trigger_source',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['zrm_properties', 'zrm_tour_scheduling'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6636
const PostListingDashboardModalSetTourAvailabilityButton = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.SET_TOUR_AVAILABILITY_BUTTON,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'listing_congrats_modal',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'tour_module',
      trigger_source_nm: 'setup_tour_availability',
    },
    semantic: {
      semantic_event_nm: 'tour_scheduling_entrypoint',
      topic_tag_txt: ['zrm_properties', 'zrm_tour_scheduling'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

const PostListingWorkflowCSEvents = {
  PostListingDashboardModalSetScreeningPreferencesButton,
  PostListingDashboardModalSetTourAvailabilityImpression,
  PostListingDashboardModalSetTourAvailabilityButton,
};

// Clickstream visualizer data-eventid attributes
PostListingDashboardModalSetScreeningPreferencesButton.data_event_id = EVENT_IDS.SET_SCREENING_PREFERENCES_BUTTON;
PostListingDashboardModalSetTourAvailabilityImpression.data_event_id = EVENT_IDS.SET_TOUR_AVAILABILITY_IMPRESSION;
PostListingDashboardModalSetTourAvailabilityButton.data_event_id = EVENT_IDS.SET_TOUR_AVAILABILITY_BUTTON;

export default PostListingWorkflowCSEvents;
